import { Table, TableRow, TableData } from '@cokitchen/cokitchen-components';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { apiService } from 'utils/api';
import { DAY } from 'utils/enum';
import { CompanyDeliveryTimeType } from './types';
import { FCBBrandType } from 'utils/constants';
import { handleApiError, timeFormatter } from 'utils/functions';

const FcbDeliveries = () => {
  const [companies, setCompanies] = useState<CompanyDeliveryTimeType[]>([]);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [filter, setFilter] = useState({
    status: FCBBrandType[0],
    search: '',
    page: 1,
    size: 10
  });
  const tableHeaders = ['Name', 'Brands', 'Delivery time', 'Days'];
  const fetchAllCompanies = async () => {
    const params = {
      page: String(filter.page),
      size: String(filter.size),
      brand_type: filter.status.value
    };
    try {
      setLoading(true);
      const res = await apiService.get('company/all/delivery-times', {
        params,
        baseUrl: process.env.REACT_APP_BUSINESS_API_URL
      });
      setCompanies(res.data.data.results);
      const totalNoOfPages = Math.ceil(res.data.data.total / filter.size);
      setPageCount(totalNoOfPages);
    } catch (err: any) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCompanies();
  }, [filter]);
  const getSelectedPage = async (val: { selected: number }) => {
    const pageNo = val.selected + 1;
    setFilter({ ...filter, page: pageNo });
  };
  return (
    <div>
      <div></div>
      <div className='flex items-center justify-between mb-8'>
        <div className='flex items-center px-2 py-[6px] rounded-[40px] border border-gray-border bg-gray-12'>
          {Object.values(FCBBrandType).map((status, index) => (
            <div
              onClick={() => setFilter({ ...filter, status, page: 1 })}
              key={index}
              className={`transition-all cursor-pointer text-gray-4 text-xs py-[4px] px-[14px] rounded-[20px] ${
                status === filter.status ? 'bg-gray-10 text-white' : ''
              }`}>
              {status.name}
            </div>
          ))}
        </div>
      </div>
      <Table
        loading={loading}
        headers={tableHeaders}
        pageCount={pageCount}
        onPageChange={getSelectedPage}>
        {companies.map((company: any) => (
          <TableRow key={company.id} className='hover:bg-gray-12 table_row'>
            <TableData>
              <div className='flex items-center gap-4'>
                <div className='w-10 h-10 rounded-full overflow-hidden'>
                  {company.logo ? (
                    <img src={company.logo} alt='' className='w-full h-full object-cover' />
                  ) : (
                    <div className='w-full h-full object-cover bg-red-5 flex items-center justify-center text-white text-lg'>
                      {company?.name?.trim()?.[0]}
                    </div>
                  )}
                </div>
                <div className='flex flex-col'>
                  <h4 className='text-gray-21 mb-1 text-base'>{company?.company_name}</h4>
                  <p className='text-xs text-gray-22 font-normal'>
                    Joined {moment(company?.created_at)?.format('Do MMMM, YYYY')}
                  </p>
                </div>
              </div>
            </TableData>
            <TableData className='text-sm text-gray-21'>{company?.brand_name}</TableData>
            <TableData>
              <div className='flex flex-col'>
                <h4 className='text-xs text-gray-21 font-normal mb-1'>
                  {timeFormatter(company?.delivery_time) ?? 'None'}
                </h4>
              </div>
            </TableData>
            <TableData className='text-sm text-gray-21 flex gap-x-2'>
              {company?.operational_days?.map(
                (item: { day: number; is_active: boolean }, index: number) => {
                  if (item.is_active) {
                    return (
                      <span
                        key={index}
                        style={{
                          backgroundColor: '#EDFBEA',
                          color: '#3FB827'
                        }}
                        className={`border-[1.5px] rounded-[40px] text-xs leading-[19px] px-4 py-1`}>
                        {DAY[item.day]}
                      </span>
                    );
                  }
                }
              )}
            </TableData>
          </TableRow>
        ))}
      </Table>
    </div>
  );
};

export default FcbDeliveries;
